import React from "react";
import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";

const QuillEditorReadOnly = ({ content }) => {
  return (
    <ReactQuill
      className="read-editor"
      readOnly
      theme="snow"
      content-type="html"
      style={{ height: "100%" }}
      value={content}
      modules={{ toolbar: false }}
    />
  );
};

export default QuillEditorReadOnly;
